export default "__VITE_ASSET__BtUH_QER__"